import { render, staticRenderFns } from "./tenantOperate.vue?vue&type=template&id=0b56fbaa&scoped=true&"
import script from "./tenantOperate.vue?vue&type=script&lang=js&"
export * from "./tenantOperate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b56fbaa",
  null
  
)

export default component.exports